import { render, staticRenderFns } from "./ColorSlider.vue?vue&type=template&id=0fe9934e&"
import script from "./ColorSlider.vue?vue&type=script&lang=ts&"
export * from "./ColorSlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports